var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _c("div", { staticClass: "container" }, [
            _vm.categoryGrade === 1
              ? _c(
                  "div",
                  { staticClass: "grid-box Level-one-menu" },
                  [
                    _c("grid-category", {
                      attrs: { btnObj: _vm.btnObjOne, cuIconList: _vm.tablist },
                      on: {
                        gridClick: _vm.gridMenuClick,
                        gridBtnClick: _vm.gridBtnClick
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.categoryGrade === 2
              ? _c("div", { staticClass: "platform-box Level-two-menu" }, [
                  _c(
                    "div",
                    { staticClass: "tabbar-left-box" },
                    _vm._l(_vm.tablist, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "item",
                            { active: index === _vm.currentIndex }
                          ],
                          on: {
                            click: function($event) {
                              _vm.changeTab(index, item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.name) +
                              "\n                        "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "grid-box" },
                    [
                      _c("grid-category", {
                        attrs: {
                          ":btnObj": _vm.btnObjTwo,
                          cuIconList: _vm.categoryTwo
                        },
                        on: {
                          gridClick: _vm.gridMenuClick,
                          gridBtnClick: _vm.gridBtnClick
                        }
                      })
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.categoryGrade === 3
              ? _c("div", { staticClass: "platform-box Level-three-menu" }, [
                  _c(
                    "div",
                    { staticClass: "tabbar-left-box" },
                    _vm._l(_vm.tablist, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          class: [
                            "item",
                            { active: index === _vm.currentIndex }
                          ],
                          on: {
                            click: function($event) {
                              _vm.changeTab(index, item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.name) +
                              "\n                        "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-menu-box" }, [
                    _c(
                      "div",
                      { staticClass: "grid-box" },
                      [
                        _vm.tablist[_vm.currentIndex].name
                          ? _c(
                              "button",
                              {
                                staticClass: "gridBtn",
                                on: {
                                  click: function($event) {
                                    _vm.gridOneBtnClick(
                                      _vm.tablist[_vm.currentIndex]
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "查看" +
                                    _vm._s(_vm.tablist[_vm.currentIndex].name) +
                                    " >"
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.categoryTwo, function(item, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c("div", { staticClass: "menu-t-title" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.name) +
                                    "\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("grid-category", {
                                attrs: {
                                  btnObj: "查看" + item.name,
                                  cuIconList: item.productCategorySon,
                                  gridCol: _vm.gridColTwo,
                                  parentObj: item
                                },
                                on: {
                                  gridClick: _vm.gridMenuClick,
                                  gridBtnClick: function($event) {
                                    _vm.gridBtnClick(item)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }